export const CONST_FIELD_SEARCH_BASE = {
    ParentId: 'ParentId',
    sortField: 'sortField',
    sortOrder: 'sortOrder',
    status: 'status',
    PageIndex: 'PageIndex',
    pageNumber: 'pageNumber',
    PageSize: 'PageSize',
    rows: 'rows',
    IsPaging: 'IsPaging',
    isPaging: 'isPaging',
    keyword: 'keyword',
    Keyword: 'Keyword'
}
export const CONST_HREF_LINK_BASE = {
    LinkICON: './assets/media/svg/icons/Layout/Layout-grid.svg',
    URL: 'dashboard'
}